import type { Locale } from './types';

const messages = {
  de: {
    launcherLabel: 'Feedback geben',
    cancelPicking: 'Auswahl abbrechen',
    pickHint: 'Klicken Sie auf ein Element – Esc bricht ab',
    selectedElement: 'Ausgewähltes Element',
    commentLabel: 'Ihr Feedback',
    commentPlaceholder: 'Was ist Ihnen aufgefallen?',
    submit: 'Senden',
    cancel: 'Abbrechen',
    sending: 'Wird gesendet…',
    success: 'Danke! Ihr Feedback wurde übermittelt.',
    error: 'Senden fehlgeschlagen.',
    retry: 'Erneut versuchen',
    formatBold: 'Fett (Strg+B)',
    formatItalic: 'Kursiv (Strg+I)',
    formatCode: 'Code',
    formatList: 'Aufzählung',
    preview: 'Vorschau',
    fullscreen: 'Vollbild',
    exitFullscreen: 'Vollbild verlassen',
    emailLabel: 'E-Mail für Rückmeldung (optional)',
  },
  en: {
    launcherLabel: 'Give feedback',
    cancelPicking: 'Cancel selection',
    pickHint: 'Click an element on the page – Esc to cancel',
    selectedElement: 'Selected element',
    commentLabel: 'Your feedback',
    commentPlaceholder: 'What did you notice?',
    submit: 'Send',
    cancel: 'Cancel',
    sending: 'Sending…',
    success: 'Thanks! Your feedback has been submitted.',
    error: 'Sending failed.',
    retry: 'Try again',
    formatBold: 'Bold (Ctrl+B)',
    formatItalic: 'Italic (Ctrl+I)',
    formatCode: 'Code',
    formatList: 'Bullet list',
    preview: 'Preview',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit fullscreen',
    emailLabel: 'Email for updates (optional)',
  },
} as const satisfies Record<Locale, Record<string, string>>;

export type Messages = Record<keyof (typeof messages)['de'], string>;

export function getMessages(locale: Locale): Messages {
  return messages[locale];
}
